import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Move, MovesService } from 'src/app/services/app/moves.service';

@Component({
  selector: 'moves-report',
  templateUrl: './moves-report.component.html',
  styleUrls: ['./moves-report.component.css']
})
export class MovesReportComponent {
  
  @ViewChild('pdfContent') pdfContent: ElementRef<HTMLElement>;
  emailSent: boolean = false;
  fileDownload: boolean = false;

  today: Date = new Date();

  // pagination state
  currentPage = 1;
  pageSize = 30;
  email: string = '';

  moves: Move[];

  constructor(private dialogRef: MatDialogRef<MovesReportComponent>, private moveService: MovesService){

  }

  get startIndex() {
    return (this.currentPage - 1) * this.pageSize;
  }

  get endIndex() {
    return this.currentPage * this.pageSize;
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  get totalPages() {
    return Math.ceil(this.moves.length / this.pageSize);
  }

  async download(){
    
    for (let i = 1; i <= this.totalPages; i++) {
      this.currentPage = i;
      // let Angular render the new page first
      await new Promise(r => setTimeout(r));
      const element = this.pdfContent.nativeElement as HTMLElement;
      this.moveService.downLoadReport(element);
      this.dialogRef.close();
    }

    // odf stuff here
  }

  async sendEmail(){
    const blobs = []
    for (let i = 1; i <= this.totalPages; i++) {
      this.currentPage = i;
      // let Angular render the new page first
      await new Promise(r => setTimeout(r));
      const element = this.pdfContent.nativeElement as HTMLElement;
      const blob = await this.moveService.getHtmlBlob(element);
      blobs.push(blob);
    }
    const result = await this.moveService.emailReportBlob(blobs, this.email);
    this.dialogRef.close(result);

  }



}
